import { LocalesEnum } from '../../types/locales.enum'

const getMonthNames = (locale: string) => {
  switch (locale) {
    case LocalesEnum.Es:
      return [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]

    case LocalesEnum.Ru:
      return [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ]

    default:
      return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
  }
}

export const getLastDayOfMonth = (locale: string) => {
  const monthNames = getMonthNames(locale)
  const today = new Date()
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)
  const monthName = monthNames[today.getMonth()]
  const year = today.getFullYear()
  return ` ${monthName} ${lastDay.getDate()}, ${year}`
}
